import React from "react";
import { auth } from "@/api/firebase/firebase.config";
import NavigationBarUi from "./NavigationBar.ui";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { Container, Flex, Skeleton } from "@radix-ui/themes";

const NavigationBar: React.FunctionComponent = () => {
  const currentUser = auth.currentUser;
  const profile = useCurrentUserProfile((s) => s.user);

  return (
    <>
      {profile && currentUser ? (
        <NavigationBarUi currentUser={currentUser} profile={profile} />
      ) : (
        <header className="header">
          <Container
            className="header__container container"
            size="4"
            py="4"
            px="0"
          >
            <Flex justify={"end"} align="center">
              <Flex gap="2" align="center">
                <Skeleton
                  height={{ initial: "48px", lg: "56px" }}
                  loading={true}
                />
              </Flex>
            </Flex>
          </Container>
        </header>
      )}
    </>
  );
};

export default NavigationBar;
